export const commonConstants = {
    FORM_SUCCESS: 'FORM_SUCCESS',
    FORM_REQUEST: 'FORM_REQUEST',
    FORM_FAILURE: 'FORM_FAILURE',
    FILTER: 'FILTER',
    PAGE_REDIERCT: 'PAGE_REDIERCT',
};

